import { ReactNode } from 'react'
import { T } from '@transifex/react'
import { TagProps } from 'src/antd'

import { getTagColumn } from 'src/storybook/components/table-kit'

export type TAuthorizationStatus = 'active' | 'expired' | 'pending'

export const authorizationStatusLabelMap: Record<
  TAuthorizationStatus,
  ReactNode
> = {
  active: <T _str="Active" />,
  expired: <T _str="Expired" />,
  pending: <T _str="Pending" />,
}

export const authorizationStatusColorMap: Record<
  TAuthorizationStatus,
  TagProps['color']
> = {
  active: 'green',
  expired: 'default',
  pending: 'blue',
}

export const authorizationStatusTagColumn = getTagColumn(
  authorizationStatusColorMap,
  (val) => authorizationStatusLabelMap[val as TAuthorizationStatus]
)
